import React from 'react'
import { CheckedCsvInviteUser, CsvInviteUser, UserInvitationResult } from '../../../store/auth/auth'
import { Spinner } from 'react-bootstrap'
import { Tooltip } from '../../../components/Tooltip/Tooltip'
import { incorrectRowsFilter, nullFilter } from './utils'

export interface InvitationUserListProps {
  users: CsvInviteUser[] | CheckedCsvInviteUser[]
  invitationResult: UserInvitationResult[]
  isInvitationLoading: boolean
  displayErrorRecordsOnly: boolean
}

interface InvitationStatusProps {
  invitedUser: UserInvitationResult
}

const InvitationStatus = ({ invitedUser }: InvitationStatusProps) => {
  return (
    <>
      {invitedUser.isError ? (
        <span className='zocks-text-danger text-nowrap'>
          <i className='bi bi-x-circle px-2' />
          <span className='label-small'>{invitedUser.status}</span>
        </span>
      ) : (
        <span className='zocks-text-success text-nowrap'>
          <i className='bi bi-check-circle px-2' />
          <span className='label-small'>{invitedUser.status}</span>
        </span>
      )}
    </>
  )
}

interface VerificationStatusProps {
  user: CsvInviteUser | CheckedCsvInviteUser
}

const VerificationStatus = ({ user }: VerificationStatusProps) => {
  return (
    <>
      {'errors' in user && user.errors && user.errors.length === 0 ? (
        <i className='bi bi-check-circle zocks-text-success'> {user.inviteStatus?.replace('_', ' ')}</i>
      ) : null}
      {'errors' in user && user.errors && user.errors.length > 0 ? (
        <Tooltip className='paragraph-small' title={user.errors.join(', ')} placement='top' offset={[0, 10]}>
          <i className='bi bi-x-circle zocks-text-danger' />
        </Tooltip>
      ) : null}
      {!('errors' in user) ? (
        <span>
          <Spinner size='sm' />
        </span>
      ) : null}
    </>
  )
}

export interface UserEntry {
  user: CsvInviteUser | CheckedCsvInviteUser
  invitation?: UserInvitationResult
}

export const InvitationUserList = ({ users, isInvitationLoading, invitationResult, displayErrorRecordsOnly }: InvitationUserListProps) => {
  const userList: UserEntry[] = users.map((user) => ({ user, invitation: invitationResult.find((invite) => invite.email === user.email) }))

  const filteredUsers = userList.filter(displayErrorRecordsOnly ? incorrectRowsFilter : nullFilter)
  if (filteredUsers.length === 0) {
    return null
  }

  return (
    <div className='overflow-auto' style={{ height: '350px' }}>
      <table className='table mt-3'>
        <thead>
          <tr>
            <th scope='col'>Email</th>
            <th scope='col'>First name</th>
            <th scope='col'>Last name</th>
            <th scope='col'>Role</th>
            <th scope='col' className='d-flex justify-content-center'>
              Status
            </th>
          </tr>
        </thead>
        <tbody>
          {filteredUsers.map((userEntry) => {
            return (
              <tr key={`${userEntry.user.email}-${userEntry.user.firstName}-${userEntry.user.lastName}-${userEntry.user.role}`}>
                <td>{userEntry.user.email}</td>
                <td>{userEntry.user.firstName}</td>
                <td>{userEntry.user.lastName}</td>
                <td>{userEntry.user.role}</td>
                <td className={`d-flex ${userEntry.invitation ? '' : 'justify-content-center'}`}>
                  {isInvitationLoading ? (
                    <span>
                      <Spinner size='sm' />
                    </span>
                  ) : (
                    <>{userEntry.invitation ? <InvitationStatus invitedUser={userEntry.invitation} /> : <VerificationStatus user={userEntry.user} />}</>
                  )}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
